import io from 'socket.io-client';
import {fetchJson} from "./common";

let socketUrl = null;
fetchJson('/api/backend/socket-url').then(({url}) => {
    socketUrl = url;
});

export default io(socketUrl);